<template>
  <van-popup
    :value="value"
    position="bottom"
    style="height: 100%;"
    @open="initData"
    @close="hidePopup"
  >
    <van-nav-bar title="数据详情" left-arrow @click-left="hidePopup" />
    <div class="date-option">
      <div
        v-for="i in dateOption"
        :key="i.value"
        :class="{active:queryDate===i.value}"
        class="item"
        @click="getData(i.value)"
      >
        {{ i.label }}
      </div>
    </div>
    <div class="chart-title">
      {{ sensor.name }}（{{ sensor.unit }}）
    </div>
    <div class="content-wrapper">
      <wh-charts :option="chartOption" />
    </div>
  </van-popup>
</template>

<script>
import api from '@/api'
import WhCharts from '@/components/wh-charts/wh-charts'
import dayjs from 'dayjs'
import { DataZoomComponent } from 'echarts/components'
import { use } from 'echarts/core'
use([DataZoomComponent])
export default {
  name: 'SensorStatisticPopup',
  components: { WhCharts },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    deviceData: {
      type: Object,
      default: undefined
    },
    sensor: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      dateOption: [
        {
          label: '天',
          value: 1
        },
        {
          label: '周',
          value: 7
        },
        {
          label: '月',
          value: 30
        },
        {
          label: '半年',
          value: 180
        },
        {
          label: '年',
          value: 365
        }
      ],
      queryDate: 1,
      sensorData: [],
      chartOption: {
        color: ['#F87200'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          // left: 'left',
          // right: 0,
          bottom: 20,
          top: 20,
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#767676'
              }
            },
            axisLabel: {
              color: '#767676',
              fontSize: 14
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#767676'
              }
            },
            axisLabel: {
              color: '#767676',
              fontSize: 14
            },
            splitLine: {
              show: false
            }
          }
        ],
        dataZoom: [{
          type: 'inside'
        }],
        series: [
          {
            name: '数值',
            type: 'line',
            smooth: 0.5,
            lineStyle: {
              color: 'rgba(248, 114, 0, 1)'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(248, 114, 0, .3)' // 0% 处的颜色
                }, {
                  offset: 0.5, color: 'rgba(248, 114, 0, .1)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(248, 114, 0, 0)' // 0% 处的颜色
                }],
                global: false // 缺省为 false
              }
            },
            emphasis: {
              focus: 'series'
            },
            showSymbol: false,
            data: []
          }
        ]
      }
    }
  },
  methods: {
    hidePopup() {
      this.$emit('change', false)
    },
    getData(day) {
      if (day) {
        this.queryDate = day
      }
      const startTime = new Date().getTime() - 86400000 * this.queryDate
      const endTime = new Date().getTime()
      const { productKey, deviceName } = this.deviceData
      api.getDataHistory({
        startTime,
        endTime,
        productKey,
        deviceName,
        queryType: 'day'
      }).then(({ data }) => {
        this.chartOption.series[0].data = (data[this.sensor.identifier] || []).reverse().map(i => {
          return [dayjs(parseInt(i.Time)).format('MM-DD HH'), i.Value]
        })
      })
    },
    initData() {
      this.getData(1)
    }
  }
}
</script>

<style lang="less" scoped>
.date-option {
  margin: 27px 20px 32px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  text-align: center;
  justify-items: center;
  .item {
    width: 48px;
    height: 48px;
    line-height: 48px;
    border-radius: 50%;
    font-size: 16px;
    font-weight: 500;
    transition: all .2s;
    background: #D8D8D8;
    color: #fff;
    &.active {
      background: @primary-color;
      border-color: @primary-color;
    }
  }
}
.chart-title {
  margin: 0 20px;
  font-size: 18px;
  font-weight: 500;
  color: #3D3D3D;
}
.content-wrapper {
  margin: 60px 10px;
}
</style>
